import React from "react";
import styles from './Home.module.css';

const Home = () => {
    return (
        <>
            <div id="home" className={styles.home}>
                <h1 className="wow bounceIn"><span className={styles.ct}>CONTACTEZ,</span>ON</h1>
                <h1 className="wow bounceIn">S'OCCUPE DU <span className={styles.cr}>RESTE</span></h1>
                <p className="wow bounceIn">Vos désirs seront bien exécutés .</p>
                <a className="wow bounceIn" href="#contact">CONTACTEZ NOUS</a>
            </div>
        </>
    );
}
export default Home;